// @flow

import DOM from '../../util/dom';
import config from '../../util/config';
import {extend, convertToSelectedUnit} from '../../util/util';
import Popup from '../popup';
import {ClickControlBase} from './click_control_base';
import {MapMouseEvent, MapTouchEvent} from '../events';
import type {Options} from './click_control_base';
import {Common} from '../../util/enums';

/**
 * The `TruckRestrictionClickControl` adds the ability to show a popup when a Truck Restriction Icon  is clicked on.
 *
 * @implements {IControl}
 *
 * @example
 * var truckRestrictionClickControl = TrimbleMaps.TruckRestrictionClickControl();
 * map.addControl(truckRestrictionClickControl);
 */
class TruckRestrictionClickControl extends ClickControlBase {
    constructor(options: Options) {
        const opt = extend({layerId: 'truckrestrictions'}, options);
        super(opt);
    }

    _onClick(event: MapMouseEvent | MapTouchEvent) {
        // $FlowFixMe
        const features = event.features;

        if (features && features.length > 0) {
            const popupContentContainer = DOM.create('div', 'trimblemaps-ctrl-trpopup');
            const popupText = features.flatMap((f) => {
                let length;
                let height;
                let weight;
                let width;
                if (config.UNIT && config.UNIT !== null && typeof (config) !== undefined) {
                    const unit = config.UNIT === Common.Unit.METRIC ? Common.DistanceUnit.KILOMETERS : Common.DistanceUnit.MILES;
                    if (typeof (f.properties.length) !== 'undefined' && f.properties.length > 0) {
                        length = `Max Length: ${String(convertToSelectedUnit(false, f.properties.length, 'length', unit))} ${config.UNIT === Common.TruckUnit.METRIC ? 'mt' : ''}`;
                    }
                    if (typeof (f.properties.height) !== 'undefined' && f.properties.height > 0) {
                        height = `Max Height: ${String(convertToSelectedUnit(false, f.properties.height, 'height', unit))} ${config.UNIT === Common.TruckUnit.METRIC ? 'mt' : ''}`;
                    }
                    if (typeof (f.properties.weight) !== 'undefined' && f.properties.weight > 0) {
                        weight = `Max Weight: ${String(convertToSelectedUnit(false, f.properties.weight, 'weight', unit))} ${config.UNIT === Common.TruckUnit.METRIC ? 'kg' : 'lbs/gallon'}`;
                    }
                    if (typeof (f.properties.width) !== 'undefined' && f.properties.width > 0) {
                        width = `Max Width: ${String(convertToSelectedUnit(false, f.properties.width, 'width', unit))} ${config.UNIT === Common.TruckUnit.METRIC ? 'mt' : ''}`;
                    }
                } else {
                    if (typeof (f.properties.length) !== 'undefined' && f.properties.length > 0) {
                        length = `Max Length: ${String(convertToSelectedUnit(false, f.properties.length, 'length', Common.DistanceUnit.MILES))} ${config.UNIT === Common.TruckUnit.METRIC ? 'mt' : ''}`;
                    }
                    if (typeof (f.properties.height) !== 'undefined' && f.properties.height > 0) {
                        height = `Max Height: ${String(convertToSelectedUnit(false, f.properties.height, 'height', Common.DistanceUnit.MILES))} ${config.UNIT === Common.TruckUnit.METRIC ? 'mt' : ''}`;
                    }
                    if (typeof (f.properties.weight) !== 'undefined' && f.properties.weight > 0) {
                        weight = `Max Weight: ${String(convertToSelectedUnit(false, f.properties.weight, 'weight', Common.DistanceUnit.MILES))} ${config.UNIT === Common.TruckUnit.METRIC ? 'kg' : 'lbs/gallon'}`;
                    }
                    if (typeof (f.properties.width) !== 'undefined' && f.properties.width > 0) {
                        width = `Max Width: ${String(convertToSelectedUnit(false, f.properties.width, 'width', Common.DistanceUnit.MILES))} ${config.UNIT === Common.TruckUnit.METRIC ? 'mt' : ''}`;
                    }
                }

                return f.properties.length || f.properties.width || f.properties.height || f.properties.weight ? [length, width, height, weight].filter(val => !!val).join('<br/>') : f.properties.description.split(',');
            }) // split any multi element descriptions
                .filter((v, i, a) => a.indexOf(v) === i) // remove any duplicates picked up from nearby features
                .join('<br/>');

            popupContentContainer.innerHTML = popupText;
            this._popup = new Popup({})
                .setLngLat(features[0].geometry.coordinates)
                .setDOMContent(popupContentContainer);
            if (this._options.showPopup) {
                this._popup.addTo(this._map);
            }
            this._clickControlEventHandler();

            event.preventDefault();
        }
    }

    _onContentFilter(e: Object) {
        if (e.id === 'truckrestrictions') {
            if (this._popup && this._popup.isOpen()) this._popup.remove();
        }
    }
}

export default TruckRestrictionClickControl;
